import { ReactNode, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase/firebase';

interface notSignedInWrapperProps {
    children: ReactNode;
}

export const NotSignedInWrapper: React.FC<notSignedInWrapperProps> = ({
    children,
}) => {
    const navigate = useNavigate();
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        auth.authStateReady().then(() => {
            setIsLoaded(true);
        });
    }, []);

    useEffect(() => {
        if (auth.currentUser) {
            navigate('/');
        }
    });

    if (!isLoaded || auth.currentUser) {
        return <></>;
    }

    return <>{children}</>;
};
